import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAdmin } from '../context/AdminContext';
import { ModalPagoCliente } from './PagosCliente';
import { ModalCobroCliente } from '../components/ModalCobroCliente';
import PreviewCorreo from '../components/PreviewCorreo';
import { formatFecha as fmtFecha } from '../utils/fecha';

import { API } from '../config/api';
const ESTADOS_COBRO   = ['Pendiente', 'Parcial', 'Facturada', 'Cobrada', 'Anulado'];
const EMPRESAS_FACT   = ['JyA Conusa', 'Cuenta Personal (JCNS)'];

const fmt = (n, moneda) => {
  const sym = moneda === 'Dólares' ? '$' : '₡';
  return `${sym}${Number(n || 0).toLocaleString('es-CR', { minimumFractionDigits: 2 })}`;
};
// v18: 'Cobrada' = saldo cero; 'Anulado' = fuera de circulación. Ninguna vence.
const esVencido = (fecha, estado) => fecha && estado !== 'Cobrada' && estado !== 'Anulado' && new Date(fecha) < new Date();

const badgeSolicitud = (estado) => {
  if (!estado) return <span style={{ color: '#ccc', fontSize: 11 }}>—</span>;
  const map = { 'Solicitada': { bg: '#e6f1fb', color: '#185FA5' }, 'Facturada': { bg: '#eaf3de', color: '#3B6D11' } };
  const s = map[estado] || { bg: '#f0f0f0', color: '#666' };
  return <span style={{ ...s, padding: '2px 9px', borderRadius: 99, fontSize: 10, fontWeight: 600 }}>{estado}</span>;
};

const estadoBadge = (estado, fechaVenc) => {
  const vencido = esVencido(fechaVenc, estado);
  const map = {
    'Pendiente': { bg: '#fff8e1', color: '#854F0B' },
    'Parcial':   { bg: '#e6f1fb', color: '#185FA5' },
    'Facturada': { bg: '#e6f1fb', color: '#185FA5' },
    'Cobrada':   { bg: '#eaf3de', color: '#3B6D11' },
    'Vencido':   { bg: '#FCEBEB', color: '#A32D2D' },   // label computed, no persistido
    'Anulado':   { bg: '#f0f0f0', color: '#666' },
  };
  const s = (vencido && estado === 'Pendiente') ? map['Vencido'] : map[estado] || map['Pendiente'];
  const label = (vencido && estado === 'Pendiente') ? 'Vencido' : estado;
  return <span style={{ ...s, padding: '2px 10px', borderRadius: 99, fontSize: 11, fontWeight: 500 }}>{label}</span>;
};

const inputStyle = {
  padding: '8px 12px', border: '1px solid #e0e0e0', borderRadius: '8px',
  fontSize: '13px', outline: 'none', width: '100%', boxSizing: 'border-box',
  fontFamily: 'Segoe UI, sans-serif'
};

const ModalEliminar = ({ titulo, descripcion, onConfirm, onCancel }) => (
  <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200 }}>
    <div style={{ background: '#fff', borderRadius: '16px', padding: '28px', width: '420px', boxShadow: '0 8px 32px rgba(0,0,0,0.18)' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
        <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: '#FCEBEB', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M10 4v6M10 13v1" stroke="#A32D2D" strokeWidth="1.8" strokeLinecap="round" />
            <circle cx="10" cy="10" r="8.5" stroke="#A32D2D" strokeWidth="1.4" />
          </svg>
        </div>
        <div>
          <div style={{ fontSize: '15px', fontWeight: '600', color: '#012E40' }}>{titulo}</div>
          <div style={{ fontSize: '12px', color: '#888', marginTop: '2px' }}>{descripcion}</div>
        </div>
      </div>
      <p style={{ fontSize: '13px', color: '#555', lineHeight: '1.6', margin: '0 0 20px' }}>
        ¿Estás seguro que querés eliminar este registro de forma permanente? Esta acción <strong>no se puede deshacer</strong> y eliminará los hitos y pagos asociados.
      </p>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
        <button onClick={onCancel} style={{ padding: '8px 20px', border: '1px solid #e0e0e0', borderRadius: '8px', background: '#fff', cursor: 'pointer', fontSize: '13px' }}>Cancelar</button>
        <button onClick={onConfirm} style={{ padding: '8px 20px', background: '#A32D2D', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>Sí, eliminar</button>
      </div>
    </div>
  </div>
);

export default function CobrosCliente() {
  const isAdmin = useAdmin();
  const [lista, setLista]                 = useState([]);
  const [clientes, setClientes]           = useState([]);
  const [proyectos, setProyectos]         = useState([]);
  const [filtro, setFiltro]               = useState('');
  const [filtroEst, setFiltroEst]         = useState('');
  const [filtroEmpresa, setFiltroEmpresa] = useState('');
  const [modal, setModal]                 = useState(false);
  const [detalle, setDetalle]             = useState(null);
  const [cobroInicial, setCobroInicial]   = useState(null);  // estado inicial pasado a ModalCobroCliente
  const [editando, setEditando]           = useState(false);
  const [cargando, setCargando]           = useState(true);
  const [modalEliminar, setModalEliminar] = useState(null);
  const [pagoCliente, setPagoCliente]     = useState(null);   // cobro abierto en ModalPagoCliente
  const [anular, setAnular]               = useState(null);   // cobro en proceso de anulacion
  const [anularMotivo, setAnularMotivo]   = useState('');
  const [anularEnviando, setAnularEnviando] = useState(false);
  const [solicitudModal, setSolicitudModal]       = useState(false); // abre modal confirmación grupal
  const [solicitudEnviando, setSolicitudEnviando] = useState(false);
  const [hitosSeleccionados, setHitosSeleccionados] = useState([]); // IDs seleccionados para solicitud
  const [tabFactura, setTabFactura]               = useState('todas'); // 'todas' | 'pendientes' | 'facturadas'
  const [preview, setPreview]                     = useState(null);  // vista previa de correo antes de enviar

  useEffect(() => { cargar(); }, []);
  useEffect(() => { setHitosSeleccionados([]); }, [detalle?.id]);

  // Helpers selección múltiple
  const hitosElegibles = (hitos) => (hitos || []).filter(h => !h.fecha_pago && h.estado_solicitud !== 'Facturada' && h.estado_solicitud !== 'Solicitada');
  const toggleHito     = (id) => setHitosSeleccionados(sel => sel.includes(id) ? sel.filter(x => x !== id) : [...sel, id]);
  const toggleTodos    = () => {
    const elegibles = hitosElegibles(detalle?.hitos).map(h => h.id);
    const todosMarcados = elegibles.length > 0 && elegibles.every(id => hitosSeleccionados.includes(id));
    setHitosSeleccionados(todosMarcados ? [] : elegibles);
  };

  const cargar = async () => {
    setCargando(true);
    try {
      const [rC, rCl, rP] = await Promise.all([
        axios.get(`${API}/cobros-cliente`),
        axios.get(`${API}/clientes`),
        axios.get(`${API}/proyectos`),
      ]);
      const sorted = [...rC.data].sort((a, b) => {
        const nA = parseInt((a.numero_factura_cliente || '').replace(/\D/g, '')) || 0;
        const nB = parseInt((b.numero_factura_cliente || '').replace(/\D/g, '')) || 0;
        return nB - nA;
      });
      setLista(sorted); setClientes(rCl.data); setProyectos(rP.data);
    } catch (e) { console.error(e); }
    setCargando(false);
  };

  const formVacio = () => ({
    cliente_id: '', numero_proyecto: '', numero_factura_cliente: '',
    descripcion: '', moneda: 'Dólares', facturar_con: 'JyA Conusa',
    fecha_emision: new Date().toISOString().split('T')[0],
    fecha_vencimiento: '', estado: 'Pendiente', notas: '',
    hitos: [{ numero_hito: 1, descripcion: 'Anticipo', monto: '', fecha_pago: '', iva_porcentaje: 13, _sel: true }]
  });

  const abrirNuevo = () => { setCobroInicial(formVacio()); setEditando(false); setModal(true); };

  const abrirEditar = async (cobro) => {
    try {
      const res = await axios.get(`${API}/cobros-cliente?id=${cobro.id}`);
      const d = res.data;
      setCobroInicial({
        ...d,
        fecha_emision: d.fecha_emision ? d.fecha_emision.split('T')[0] : '',
        fecha_vencimiento: d.fecha_vencimiento ? d.fecha_vencimiento.split('T')[0] : '',
        hitos: (d.hitos || []).map(h => ({
          ...h,
          fecha_pago:      h.fecha_pago ? h.fecha_pago.split('T')[0] : '',
          iva_porcentaje:  h.iva_porcentaje ?? 13,
          oferta_linea_id: h.oferta_linea_id || null,
          _sel:            true
        }))
      });
      setEditando(true); setDetalle(null); setModal(true);
    } catch (e) { console.error(e); }
  };

  const verDetalle = async (cobro) => {
    try {
      const res = await axios.get(`${API}/cobros-cliente?id=${cobro.id}`);
      setDetalle(res.data);
    } catch (e) { console.error(e); }
  };

  const confirmarEliminar = async () => {
    if (!modalEliminar) return;
    try {
      await axios.delete(`${API}/cobros-cliente?id=${modalEliminar.id}&hard=true`);
      setModalEliminar(null); setDetalle(null); await cargar();
    } catch (e) { alert('Error al eliminar: ' + (e.response?.data?.error || e.message)); }
  };

  // ── SOLICITUD DE FACTURA (grupal) ─────────────────────────────────────────
  const confirmarSolicitud = () => {
    if (!hitosSeleccionados.length) return;
    const ids = hitosSeleccionados.join(',');
    // Abrir vista previa; el correo solo se envia al confirmar en el modal de preview.
    setPreview({
      titulo: 'Solicitud de factura',
      previewUrl: `${API}/cobros-cliente?action=preview-factura&hito_ids=${ids}`,
      sendUrl:    `${API}/cobros-cliente?action=solicitar-factura&hito_ids=${ids}`,
      enviarLabel: 'Enviar solicitud',
      onSent: async () => {
        setPreview(null);
        setSolicitudModal(false);
        setHitosSeleccionados([]);
        if (detalle) {
          try { const res = await axios.get(`${API}/cobros-cliente?id=${detalle.id}`); setDetalle(res.data); } catch (_) {}
        }
        await cargar();
      }
    });
  };

  const marcarFacturada = async (hito) => {
    if (!window.confirm(`¿Marcar "${hito.descripcion || `Hito ${hito.numero_hito}`}" como Facturada?`)) return;
    try {
      await axios.post(`${API}/cobros-cliente?action=marcar-facturada&hito_id=${hito.id}`);
      if (detalle) {
        const res = await axios.get(`${API}/cobros-cliente?id=${detalle.id}`);
        setDetalle(res.data);
      }
      await cargar();
    } catch (e) { alert('Error: ' + (e.response?.data?.error || e.message)); }
  };

  // ── PAGO ──────────────────────────────────────────────────────────────────
  // El registro de pagos se delega 100% a PagosCliente vía ModalPagoCliente.
  // El estado de la factura se recalcula en el API cuando se inserta/borra un pago.
  const abrirPagoCliente = (cobro) => {
    setPagoCliente({
      id:                     cobro.id,
      numero_factura_cliente: cobro.numero_factura_cliente,
      cliente_nombre:         cobro.cliente_nombre,
      moneda:                 cobro.moneda,
      monto_sin_iva:          cobro.monto_sin_iva,
      monto_iva:              cobro.monto_iva,
      monto_total:            cobro.monto_total,
      numero_proyecto:        cobro.numero_proyecto
    });
  };

  // ── ANULACION ─────────────────────────────────────────────────────────────
  // Envia correo al encargado pidiendo anular la factura y marca el cobro como
  // 'Anulado' (decision JC: inmediato al enviar). Motivo obligatorio.
  const confirmarAnulacion = () => {
    if (!anular) return;
    const motivo = anularMotivo.trim();
    if (!motivo) return;
    const id = anular.id;
    // Abrir vista previa; la anulacion (correo + cambio de estado) solo ocurre al confirmar.
    setPreview({
      titulo: 'Solicitud de anulacion',
      previewUrl: `${API}/cobros-cliente?action=preview-anulacion&id=${id}`,
      sendUrl:    `${API}/cobros-cliente?action=solicitar-anulacion&id=${id}`,
      body: { motivo },
      enviarLabel: 'Enviar solicitud de anulacion',
      onSent: async () => {
        setPreview(null);
        setAnular(null); setAnularMotivo(''); setDetalle(null);
        await cargar();
      }
    });
  };

  const montoConIva = (h) => {
    const base = parseFloat(h.monto) || 0;
    const iva  = parseFloat(h.iva_porcentaje ?? 13) || 0;
    return base * (1 + iva / 100);
  };
  // Prefiere monto_total del API (tras migración v18). Fallback: suma hitos c/IVA.
  const totalCobro = (cobro) => {
    if (cobro.monto_total != null) return parseFloat(cobro.monto_total) || 0;
    return (cobro.hitos || []).reduce((s, h) => s + montoConIva(h), 0);
  };
  // Prefiere pagado del API (SUM PagosCliente). Fallback: hitos con fecha_pago.
  const cobradoCobro = (cobro) => {
    if (cobro.pagado != null) return parseFloat(cobro.pagado) || 0;
    if (cobro.estado === 'Cobrada') return totalCobro(cobro);
    return (cobro.hitos || []).filter(h => h.fecha_pago).reduce((s, h) => s + montoConIva(h), 0);
  };
  const pendienteCobro = (cobro) => {
    if (cobro.saldo != null) return parseFloat(cobro.saldo) || 0;
    return totalCobro(cobro) - cobradoCobro(cobro);
  };

  // Días transcurridos desde emisión. Si el cobro ya está Cobrado, se detiene en
  // fecha_cobro_total (columna poblada por recalcularEstadoCobro en v18 cuando
  // saldo llega a cero). Fallback a hitos con fecha_pago para registros legacy
  // pre-v18 que aún no tienen fecha_cobro_total.
  const diasTranscurridos = (cobro) => {
    if (!cobro.fecha_emision) return null;
    const inicio = new Date(cobro.fecha_emision);
    let fin = new Date();
    if (cobro.estado === 'Cobrada') {
      if (cobro.fecha_cobro_total) {
        fin = new Date(cobro.fecha_cobro_total);
      } else if (cobro.hitos && cobro.hitos.length) {
        const ultimo = [...cobro.hitos]
          .filter(h => h.fecha_pago)
          .sort((a, b) => new Date(b.fecha_pago) - new Date(a.fecha_pago))[0];
        if (ultimo) fin = new Date(ultimo.fecha_pago);
      }
    }
    const diff = Math.floor((fin - inicio) / (1000 * 60 * 60 * 24));
    return diff < 0 ? 0 : diff;
  };
  // No mostrar chip si ya está Cobrada o Anulada — el chip es un indicador de
  // antigüedad de cuenta por cobrar pendiente, no tiene sentido post-cobro.
  const diasChip = (cobro) => {
    if (['Cobrada', 'Anulado'].includes(cobro.estado)) return null;
    const dias = diasTranscurridos(cobro);
    if (dias === null) return null;
    let bg, color, border;
    if (dias <= 30)      { bg = '#e8f4e4'; color = '#2d6a2d'; border = '#C0DD97'; }
    else if (dias <= 60) { bg = '#fff8e1'; color = '#854F0B'; border = '#FAC775'; }
    else                 { bg = '#FCEBEB'; color = '#A32D2D'; border = '#F7C1C1'; }
    return <span style={{ background: bg, color, border: `1px solid ${border}`, padding: '2px 9px', borderRadius: '10px', fontSize: '11px', fontWeight: '600' }}>{dias}d</span>;
  };

  const tieneSolicitada = (c) => (c.hitos || []).some(h => h.estado_solicitud === 'Solicitada');

  // Un cobro es "pendiente de facturar" si NO tiene numero_factura_cliente asignado.
  // Incluye borradores (sin solicitar) y solicitudes enviadas sin factura aún.
  const esPendienteFactura = (c) => !(c.numero_factura_cliente && String(c.numero_factura_cliente).trim());
  const esFacturada        = (c) => !esPendienteFactura(c);
  // "Cobrada" = saldo en cero. Post v19.1 el estado legacy 'Pagado' ya no existe en BD.
  const esCobrada          = (c) => c.estado === 'Cobrada';

  const countPendientes  = lista.filter(esPendienteFactura).length;
  const countFacturadas  = lista.filter(esFacturada).length;
  const countCobradas    = lista.filter(esCobrada).length;

  // Última fecha de solicitud entre los hitos de un cobro (para ordenar "Pendientes")
  const ultimaFechaSolicitud = (c) => {
    const fechas = (c.hitos || [])
      .map(h => h.fecha_solicitud)
      .filter(Boolean)
      .map(f => new Date(f).getTime());
    return fechas.length ? Math.max(...fechas) : 0;
  };

  const filtradosBase = lista.filter(c => {
    const txt = filtro.toLowerCase();
    const matchTxt = !txt || [c.numero_factura_cliente, c.numero_proyecto, c.cliente_nombre].some(v => (v || '').toLowerCase().includes(txt));
    const matchEst     = !filtroEst     || c.estado      === filtroEst;
    const matchEmpresa = !filtroEmpresa || c.facturar_con === filtroEmpresa;
    const matchTab     = tabFactura === 'todas'
                          || (tabFactura === 'pendientes' && esPendienteFactura(c))
                          || (tabFactura === 'facturadas' && esFacturada(c))
                          || (tabFactura === 'cobradas'   && esCobrada(c));
    return matchTxt && matchEst && matchEmpresa && matchTab;
  });

  // En "Pendientes" ordenar por fecha de solicitud más reciente primero.
  // En el resto respetar el orden base (por N° factura desc) ya aplicado en cargar().
  const filtrados = tabFactura === 'pendientes'
    ? [...filtradosBase].sort((a, b) => ultimaFechaSolicitud(b) - ultimaFechaSolicitud(a))
    : filtradosBase;

  // KPIs como foto del estado actual:
  //   primario  -> facturado en el mes en curso (por moneda).
  //   secundario -> saldo pendiente de meses anteriores (deuda arrastrada).
  //
  // Reglas:
  // - Operan sobre filtradosBase (respetan filtros activos: cliente, empresa,
  //   estado, tab). Coherente con la tabla.
  // - "Facturado" en este sistema = tiene numero_factura_cliente emitido
  //   (esFacturada helper), independiente del estado de cobro. El campo
  //   c.estado representa el ciclo de COBRO (Pendiente=por cobrar, Parcial,
  //   Cobrada), no el ciclo de FACTURACION. Anulado se excluye aparte.
  // - Mes se compara por YYYY-MM contra fecha_emision (ISO).
  const facturablesBase = filtradosBase.filter(c => esFacturada(c) && c.estado !== 'Anulado');

  // mesActualKey en zona horaria CR para evitar offset UTC (un cobro creado
  // 31-may 22:00 CR no debe contarse en junio).
  const mesActualKey = new Date().toLocaleDateString('en-CA', { timeZone: 'America/Costa_Rica' }).slice(0, 7);
  const _mesKey = (c) => c.fecha_emision ? String(c.fecha_emision).slice(0, 7) : null;
  const enMesActual    = (c) => _mesKey(c) === mesActualKey;
  const enMesesPrevios = (c) => { const k = _mesKey(c); return k != null && k < mesActualKey; };

  const cobrosFactMesCol  = facturablesBase.filter(c => c.moneda === 'Colones' && enMesActual(c));
  const cobrosFactMesUsd  = facturablesBase.filter(c => c.moneda === 'Dólares' && enMesActual(c));
  const cobrosPendPrevCol = facturablesBase.filter(c => c.moneda === 'Colones' && enMesesPrevios(c) && pendienteCobro(c) > 0);
  const cobrosPendPrevUsd = facturablesBase.filter(c => c.moneda === 'Dólares' && enMesesPrevios(c) && pendienteCobro(c) > 0);

  const facturadoMesColones  = cobrosFactMesCol.reduce((s, c) => s + totalCobro(c), 0);
  const facturadoMesDolares  = cobrosFactMesUsd.reduce((s, c) => s + totalCobro(c), 0);
  const pendientePrevColones = cobrosPendPrevCol.reduce((s, c) => s + pendienteCobro(c), 0);
  const pendientePrevDolares = cobrosPendPrevUsd.reduce((s, c) => s + pendienteCobro(c), 0);

  // Tooltip de desglose para diagnostico visual. Formato:
  // "Factura X (Cliente) [fecha_emision]: monto"
  const _detalle = (cobros, getMonto) => cobros.length === 0
    ? 'Sin cobros'
    : cobros.map(c => `${c.numero_factura_cliente || '?'} (${c.cliente_nombre || c.numero_proyecto || '?'}) [${(c.fecha_emision || '').slice(0,10)}]: ${Number(getMonto(c)).toLocaleString('es-CR', { minimumFractionDigits: 2 })}`).join('\n');
  const tipFactMesCol  = _detalle(cobrosFactMesCol,  totalCobro);
  const tipFactMesUsd  = _detalle(cobrosFactMesUsd,  totalCobro);
  const tipPendPrevCol = _detalle(cobrosPendPrevCol, pendienteCobro);
  const tipPendPrevUsd = _detalle(cobrosPendPrevUsd, pendienteCobro);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', fontFamily: 'Segoe UI, sans-serif' }}>

      {/* HEADER */}
      <div style={{ background: '#012E40', padding: '14px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <h1 style={{ color: '#fff', fontSize: '16px', fontWeight: '600', margin: 0 }}>Cobros a Clientes</h1>
          <span style={{ background: '#87B749', color: '#fff', fontSize: '11px', padding: '2px 10px', borderRadius: '10px', fontWeight: '500' }}>CxC</span>
        </div>
        <button onClick={abrirNuevo} style={{ padding: '8px 18px', background: 'transparent', color: '#87B749', border: '1.5px solid #87B749', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>
          + Nuevo cobro
        </button>
      </div>

      {/* STATS — foto del mes: facturado este mes + pendiente arrastrado.
          title= muestra desglose de cobros que componen cada total. */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr) repeat(2,1fr)', gap: '12px', padding: '16px 24px', background: '#f5f6f8', flexShrink: 0 }}>
        <div title={`Facturado este mes ₡ (${cobrosFactMesCol.length} cobro${cobrosFactMesCol.length===1?'':'s'})\n\n${tipFactMesCol}`}
             style={{ background: '#fff', borderRadius: '12px', padding: '16px 20px', border: '1px solid #eee', cursor: 'help' }}>
          <div style={{ fontSize: '11px', color: '#888', marginBottom: '6px', fontWeight: '500' }}>Facturado este mes ₡ <span style={{ color: '#bbb' }}>({cobrosFactMesCol.length})</span></div>
          <div style={{ fontSize: '20px', fontWeight: '700', color: '#012E40' }}>₡{Number(facturadoMesColones).toLocaleString('es-CR', { minimumFractionDigits: 2 })}</div>
        </div>
        <div title={`Facturado este mes $ (${cobrosFactMesUsd.length} cobro${cobrosFactMesUsd.length===1?'':'s'})\n\n${tipFactMesUsd}`}
             style={{ background: '#fff', borderRadius: '12px', padding: '16px 20px', border: '1px solid #eee', cursor: 'help' }}>
          <div style={{ fontSize: '11px', color: '#888', marginBottom: '6px', fontWeight: '500' }}>Facturado este mes $ <span style={{ color: '#bbb' }}>({cobrosFactMesUsd.length})</span></div>
          <div style={{ fontSize: '20px', fontWeight: '700', color: '#012E40' }}>${Number(facturadoMesDolares).toLocaleString('es-CR', { minimumFractionDigits: 2 })}</div>
        </div>
        <div title={`Pendiente meses anteriores ₡ (${cobrosPendPrevCol.length} cobro${cobrosPendPrevCol.length===1?'':'s'})\n\n${tipPendPrevCol}`}
             style={{ background: '#FCEBEB', borderRadius: '12px', padding: '16px 20px', border: '1px solid #f5c6c6', cursor: 'help' }}>
          <div style={{ fontSize: '11px', color: '#A32D2D', marginBottom: '6px', fontWeight: '500' }}>Pendiente meses anteriores ₡ <span style={{ color: '#cc9999' }}>({cobrosPendPrevCol.length})</span></div>
          <div style={{ fontSize: '20px', fontWeight: '700', color: '#A32D2D' }}>₡{Number(pendientePrevColones).toLocaleString('es-CR', { minimumFractionDigits: 2 })}</div>
        </div>
        <div title={`Pendiente meses anteriores $ (${cobrosPendPrevUsd.length} cobro${cobrosPendPrevUsd.length===1?'':'s'})\n\n${tipPendPrevUsd}`}
             style={{ background: '#FCEBEB', borderRadius: '12px', padding: '16px 20px', border: '1px solid #f5c6c6', cursor: 'help' }}>
          <div style={{ fontSize: '11px', color: '#A32D2D', marginBottom: '6px', fontWeight: '500' }}>Pendiente meses anteriores $ <span style={{ color: '#cc9999' }}>({cobrosPendPrevUsd.length})</span></div>
          <div style={{ fontSize: '20px', fontWeight: '700', color: '#A32D2D' }}>${Number(pendientePrevDolares).toLocaleString('es-CR', { minimumFractionDigits: 2 })}</div>
        </div>
      </div>

      {/* PESTAÑAS — estado de facturación */}
      <div style={{ padding: '0 24px 10px', background: '#f5f6f8', flexShrink: 0, display: 'flex', gap: '4px', borderBottom: '1px solid #e6e6e6' }}>
        {[
          { key: 'todas',       label: 'Todas',                count: lista.length      },
          { key: 'pendientes',  label: 'Facturas pendientes',  count: countPendientes   },
          { key: 'facturadas',  label: 'Facturadas',           count: countFacturadas   },
          { key: 'cobradas',    label: 'Cobradas',             count: countCobradas     },
        ].map(tab => {
          const activa = tabFactura === tab.key;
          return (
            <button key={tab.key} onClick={() => setTabFactura(tab.key)}
              style={{
                padding: '10px 18px',
                background: activa ? '#fff' : 'transparent',
                color: activa ? '#012E40' : '#666',
                border: 'none',
                borderTop: activa ? '2px solid #87B749' : '2px solid transparent',
                borderLeft: activa ? '1px solid #e6e6e6' : 'none',
                borderRight: activa ? '1px solid #e6e6e6' : 'none',
                borderRadius: '8px 8px 0 0',
                fontSize: '13px',
                fontWeight: activa ? '600' : '500',
                cursor: 'pointer',
                marginBottom: '-1px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
              {tab.label}
              <span style={{
                background: activa ? '#012E40' : '#e0e0e0',
                color: activa ? '#fff' : '#666',
                fontSize: '10px',
                fontWeight: '700',
                borderRadius: '99px',
                padding: '1px 8px',
                minWidth: '20px',
                textAlign: 'center'
              }}>{tab.count}</span>
            </button>
          );
        })}
      </div>

      {/* FILTROS */}
      <div style={{ padding: '12px 24px', background: '#f5f6f8', flexShrink: 0, display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
        <input value={filtro} onChange={e => setFiltro(e.target.value)}
          placeholder='Buscar por factura, proyecto, cliente...'
          style={{ ...inputStyle, padding: '10px 16px', fontSize: '14px', borderRadius: '10px', flex: 1, minWidth: '200px' }} />
        <select value={filtroEst} onChange={e => setFiltroEst(e.target.value)}
          style={{ ...inputStyle, padding: '10px 14px', width: '160px', borderRadius: '10px' }}>
          <option value=''>Todos los estados</option>
          {ESTADOS_COBRO.map(e => <option key={e}>{e}</option>)}
        </select>
        <select value={filtroEmpresa} onChange={e => setFiltroEmpresa(e.target.value)}
          style={{ ...inputStyle, padding: '10px 14px', width: '180px', borderRadius: '10px' }}>
          <option value=''>Todas las empresas</option>
          {EMPRESAS_FACT.map(e => <option key={e}>{e}</option>)}
        </select>
      </div>

      {/* TABLA */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '0 24px 24px', background: '#f5f6f8' }}>
        <div style={{ background: '#fff', borderRadius: '12px', border: '1px solid #eee', overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#012E40' }}>
                {['N° Factura', 'Cliente', 'Proyecto', 'Empresa', 'Moneda', 'Total', 'Cobrado', 'Saldo', 'Estado', 'Días', 'Acciones'].map(h => (
                  <th key={h} style={{ padding: '11px 14px', textAlign: 'left', fontSize: '12px', fontWeight: '500', color: '#fff', whiteSpace: 'nowrap', borderBottom: '2px solid #87B749' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {cargando
                ? <tr><td colSpan={11} style={{ textAlign: 'center', padding: '40px', color: '#aaa' }}>Cargando...</td></tr>
                : filtrados.length === 0
                  ? <tr><td colSpan={11} style={{ textAlign: 'center', padding: '40px', color: '#aaa' }}>{lista.length === 0 ? 'No hay cobros registrados aún' : 'Sin resultados'}</td></tr>
                  : filtrados.map((c, i) => {
                    const total = totalCobro(c);
                    const cobrado = cobradoCobro(c);
                    // pendienteCobro respeta el saldo del backend (0 para Anulados).
                    // Recalcular total-cobrado aqui ignoraba ese override.
                    const pendiente = pendienteCobro(c);
                    return (
                      <tr key={c.id}
                        onClick={() => verDetalle(c)}
                        style={{ borderBottom: '1px solid #f0f0f0', background: i % 2 === 0 ? '#fff' : '#fafafa', cursor: 'pointer' }}
                        onMouseOver={e => e.currentTarget.style.background = '#f0f7e8'}
                        onMouseOut={e => e.currentTarget.style.background = i % 2 === 0 ? '#fff' : '#fafafa'}>
                        <td style={{ padding: '10px 14px', fontSize: '13px', fontWeight: '500', color: '#012E40' }}>{c.numero_factura_cliente}</td>
                        <td style={{ padding: '10px 14px', fontSize: '12px', color: '#555', maxWidth: '140px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.cliente_nombre}</td>
                        <td style={{ padding: '10px 14px', fontSize: '12px', color: '#555' }}>{c.numero_proyecto || '—'}</td>
                        <td style={{ padding: '10px 14px', fontSize: '11px', color: '#666' }}>{c.facturar_con === 'JyA Conusa' ? 'JyA' : 'Personal'}</td>
                        <td style={{ padding: '10px 14px', fontSize: '12px', color: '#555' }}>{c.moneda}</td>
                        <td style={{ padding: '10px 14px', fontSize: '12px', fontWeight: '600', color: '#012E40' }}>{fmt(total, c.moneda)}</td>
                        <td style={{ padding: '10px 14px', fontSize: '12px', color: '#3B6D11', fontWeight: '500' }}>{fmt(cobrado, c.moneda)}</td>
                        <td style={{ padding: '10px 14px', fontSize: '12px', color: pendiente > 0 ? '#A32D2D' : '#3B6D11', fontWeight: '600' }}>{fmt(pendiente, c.moneda)}</td>
                        <td style={{ padding: '10px 14px' }}>{estadoBadge(c.estado, c.fecha_vencimiento)}</td>
                        <td style={{ padding: '10px 14px' }}>{diasChip(c)}</td>
                        <td style={{ padding: '10px 14px', whiteSpace: 'nowrap' }}>
                          <button onClick={e => { e.stopPropagation(); abrirEditar(c); }} style={{ padding: '4px 12px', background: 'none', border: '1px solid #ddd', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', color: '#555', marginRight: '6px' }}>Editar</button>
                          {c.estado !== 'Anulado' && !esCobrada(c) && esFacturada(c) && (
                            <button onClick={e => { e.stopPropagation(); abrirPagoCliente(c); }} style={{ padding: '4px 12px', background: '#87B749', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: '600', cursor: 'pointer', marginRight: isAdmin ? '6px' : '0' }}>Registrar pago</button>
                          )}
                          {isAdmin && (
                            <button onClick={e => { e.stopPropagation(); setModalEliminar(c); }} style={{ padding: '4px 10px', background: '#fff', color: '#A32D2D', border: '1px solid #fcc', borderRadius: '6px', fontSize: '11px', fontWeight: '500', cursor: 'pointer' }}>Eliminar</button>
                          )}
                        </td>
                      </tr>
                    );
                  })
              }
            </tbody>
          </table>
        </div>
      </div>

      {/* MODAL DETALLE */}
      {detalle && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 }}>
          <div style={{ background: '#fff', borderRadius: '16px', padding: '28px', width: '680px', maxHeight: '88vh', overflowY: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '20px' }}>
              <div>
                <h3 style={{ color: '#012E40', fontSize: '18px', fontWeight: '700', margin: '0 0 6px' }}>Factura {detalle.numero_factura_cliente}</h3>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                  {estadoBadge(detalle.estado, detalle.fecha_vencimiento)}
                  <span style={{ background: '#f0f0f0', color: '#555', fontSize: '11px', padding: '2px 8px', borderRadius: '10px' }}>{detalle.cliente_nombre}</span>
                  <span style={{ background: '#e6f1fb', color: '#185FA5', fontSize: '11px', padding: '2px 8px', borderRadius: '10px' }}>{detalle.moneda}</span>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                {detalle.estado !== 'Anulado' && esFacturada(detalle) && !esCobrada(detalle) && (
                  <button onClick={() => { setDetalle(null); abrirPagoCliente(detalle); }} style={{ padding: '7px 14px', background: '#87B749', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>Registrar pago</button>
                )}
                {detalle.estado !== 'Anulado' && detalle.numero_factura_cliente && (
                  <button onClick={() => { setAnular(detalle); setAnularMotivo(''); }} style={{ padding: '7px 14px', background: '#fff', color: '#A32D2D', border: '1px solid #A32D2D', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>Anular factura</button>
                )}
                <button onClick={() => abrirEditar(detalle)} style={{ padding: '7px 14px', background: '#012E40', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', cursor: 'pointer' }}>Editar</button>
                {isAdmin && <button onClick={() => setModalEliminar(detalle)} style={{ padding: '7px 14px', background: '#A32D2D', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', cursor: 'pointer' }}>Eliminar</button>}
                <button onClick={() => setDetalle(null)} style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer', color: '#aaa' }}>×</button>
              </div>
            </div>

            {/* Info general */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '8px', marginBottom: '16px' }}>
              {[['Proyecto', detalle.numero_proyecto || '—'], ['Facturar con', detalle.facturar_con], ['Emisión', fmtFecha(detalle.fecha_emision)], ['Vencimiento', fmtFecha(detalle.fecha_vencimiento)], ['Moneda', detalle.moneda], ['Estado', detalle.estado]].map(([label, val]) => (
                <div key={label} style={{ background: '#f8f8f8', borderRadius: '8px', padding: '8px 12px' }}>
                  <div style={{ fontSize: '10px', color: '#aaa', marginBottom: '3px' }}>{label}</div>
                  <div style={{ fontSize: '13px', color: '#012E40', fontWeight: '500' }}>{val}</div>
                </div>
              ))}
            </div>

            {/* Hitos */}
            {detalle.hitos && detalle.hitos.length > 0 && (
              <>
                {/* Header hitos: select-all + botón grupal */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px', paddingBottom: '6px', borderBottom: '1px solid #eee' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <input type="checkbox"
                      style={{ width: '14px', height: '14px', cursor: 'pointer', accentColor: '#185FA5' }}
                      checked={hitosElegibles(detalle.hitos).length > 0 && hitosElegibles(detalle.hitos).every(h => hitosSeleccionados.includes(h.id))}
                      ref={el => { if (el) el.indeterminate = hitosSeleccionados.length > 0 && !hitosElegibles(detalle.hitos).every(h => hitosSeleccionados.includes(h.id)); }}
                      onChange={toggleTodos}
                      title="Seleccionar todos los elegibles"
                    />
                    <span style={{ fontSize: '12px', fontWeight: '600', color: '#012E40' }}>Hitos de cobro</span>
                  </div>
                  {hitosSeleccionados.length > 0 && (
                    <button onClick={() => setSolicitudModal(true)}
                      style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '5px 12px', background: '#185FA5', color: '#fff', border: 'none', borderRadius: '7px', fontSize: '11px', fontWeight: '600', cursor: 'pointer' }}>
                      📤 Solicitar {hitosSeleccionados.length} hito{hitosSeleccionados.length > 1 ? 's' : ''}
                    </button>
                  )}
                </div>

                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px', marginBottom: '12px' }}>
                  <thead>
                    <tr style={{ background: '#f5f5f5' }}>
                      {['', '#', 'Descripción', 'Línea oferta', 'Fecha Pago', 'Total c/IVA', 'Estado', ''].map((h, i) => (
                        <th key={i} style={{ padding: '8px 10px', textAlign: h === 'Total c/IVA' ? 'right' : 'left', color: '#666', fontWeight: '500', fontSize: '11px' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {detalle.hitos.map(h => {
                      const pagado      = !!h.fecha_pago;
                      const solicitada  = h.estado_solicitud === 'Solicitada';
                      const facturada   = h.estado_solicitud === 'Facturada';
                      const elegible    = !pagado && !facturada && !solicitada;
                      const seleccionado = hitosSeleccionados.includes(h.id);
                      return (
                        <tr key={h.id} style={{ borderTop: '1px solid #f0f0f0', background: seleccionado ? '#ebf3fd' : facturada ? '#f4fbed' : solicitada ? '#f0f6ff' : '#fff' }}>
                          <td style={{ padding: '8px 6px', width: '24px' }}>
                            {elegible && (
                              <input type="checkbox" checked={seleccionado} onChange={() => toggleHito(h.id)}
                                style={{ width: '14px', height: '14px', cursor: 'pointer', accentColor: '#185FA5' }} />
                            )}
                          </td>
                          <td style={{ padding: '8px 10px', color: '#aaa' }}>{h.numero_hito}</td>
                          <td style={{ padding: '8px 10px' }}>
                            <div>{h.descripcion}</div>
                            <div style={{ fontSize: '10px', color: '#888' }}>{fmt(h.monto, detalle.moneda)} + {h.iva_porcentaje ?? 13}% IVA</div>
                          </td>
                          <td style={{ padding: '8px 10px', fontSize: '11px', color: '#555' }}>
                            {h.oferta_linea_descripcion
                              ? <span style={{ background: '#f0f7e8', color: '#3B6D11', padding: '2px 7px', borderRadius: 8, fontSize: 10, fontWeight: 600 }}>{h.oferta_linea_descripcion}</span>
                              : <span style={{ color: '#ccc' }}>—</span>}
                          </td>
                          <td style={{ padding: '8px 10px', color: pagado ? '#3B6D11' : '#aaa', whiteSpace: 'nowrap' }}>
                            {pagado ? fmtFecha(h.fecha_pago) : '—'}
                          </td>
                          <td style={{ padding: '8px 10px', textAlign: 'right', fontWeight: '600', color: '#012E40' }}>
                            {fmt(montoConIva(h), detalle.moneda)}
                          </td>
                          <td style={{ padding: '8px 10px' }}>{badgeSolicitud(h.estado_solicitud)}</td>
                          <td style={{ padding: '8px 6px', whiteSpace: 'nowrap' }}>
                            {solicitada && (
                              <button onClick={() => marcarFacturada(h)}
                                style={{ padding: '4px 10px', background: '#eaf3de', color: '#3B6D11', border: '1px solid #87B749', borderRadius: '6px', fontSize: '11px', fontWeight: '600', cursor: 'pointer' }}>
                                ✓ Facturada
                              </button>
                            )}
                            {(pagado || facturada) && (
                              <span style={{ color: '#ccc', fontSize: 11 }}>—</span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot>
                    <tr style={{ borderTop: '2px solid #012E40' }}>
                      <td colSpan={5} style={{ padding: '10px', fontWeight: '700', color: '#012E40', textAlign: 'right', fontSize: '13px' }}>Total con IVA</td>
                      <td style={{ padding: '10px', textAlign: 'right', fontWeight: '700', color: '#012E40', fontSize: '15px' }}>{fmt(totalCobro(detalle), detalle.moneda)}</td>
                      <td colSpan={2}></td>
                    </tr>
                  </tfoot>
                </table>
              </>
            )}
          </div>
        </div>
      )}

      {/* MODAL FORMULARIO */}
      {modal && (
        <ModalCobroCliente
          editando={editando}
          initialForm={cobroInicial}
          clientes={clientes}
          proyectos={proyectos}
          onClose={() => setModal(false)}
          onSaved={() => { setModal(false); cargar(); }}
        />
      )}

      {/* MODAL ELIMINAR */}
      {modalEliminar && (
        <ModalEliminar
          titulo="Eliminar cobro"
          descripcion={`${modalEliminar.numero_factura_cliente} — ${modalEliminar.cliente_nombre}`}
          onConfirm={confirmarEliminar}
          onCancel={() => setModalEliminar(null)}
        />
      )}

      {/* MODAL CONFIRMAR SOLICITUD DE FACTURA (grupal) */}
      {solicitudModal && (() => {
        const hitosModal  = (detalle?.hitos || []).filter(h => hitosSeleccionados.includes(h.id));
        const subtotalMod = hitosModal.reduce((s, h) => s + (parseFloat(h.monto) || 0), 0);
        const totalMod    = hitosModal.reduce((s, h) => s + montoConIva(h), 0);
        return (
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200 }}>
            <div style={{ background: '#fff', borderRadius: '16px', padding: '28px', width: '580px', maxWidth: '96vw', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 8px 32px rgba(0,0,0,0.18)' }}>

              {/* Header */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: '#e6f1fb', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: '20px' }}>📤</div>
                <div>
                  <div style={{ fontSize: '15px', fontWeight: '600', color: '#012E40' }}>Solicitar factura</div>
                  <div style={{ fontSize: '12px', color: '#888', marginTop: '2px' }}>
                    {detalle?.numero_proyecto} · {hitosModal.length} hito{hitosModal.length > 1 ? 's' : ''} seleccionado{hitosModal.length > 1 ? 's' : ''}
                  </div>
                </div>
              </div>

              {/* Info cobro */}
              <div style={{ background: '#f8f9fa', borderRadius: '8px', padding: '12px 14px', marginBottom: '16px', fontSize: '12px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px' }}>
                <div><span style={{ color: '#888' }}>Cliente: </span><span style={{ fontWeight: '600', color: '#012E40' }}>{detalle?.cliente_nombre}</span></div>
                <div><span style={{ color: '#888' }}>Empresa: </span><span style={{ fontWeight: '600', color: '#012E40' }}>{detalle?.facturar_con}</span></div>
                <div><span style={{ color: '#888' }}>Proyecto: </span><span style={{ fontWeight: '600', color: '#012E40' }}>{detalle?.numero_proyecto}</span></div>
                <div><span style={{ color: '#888' }}>Moneda: </span><span style={{ fontWeight: '600', color: '#012E40' }}>{detalle?.moneda}</span></div>
              </div>

              {/* Tabla hitos seleccionados */}
              <div style={{ fontSize: '11px', fontWeight: '700', color: '#555', textTransform: 'uppercase', letterSpacing: '.5px', marginBottom: '8px' }}>
                Hitos incluidos en esta solicitud
              </div>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px', border: '1px solid #eee', marginBottom: '12px' }}>
                <thead>
                  <tr style={{ background: '#f5f5f5' }}>
                    {['#', 'Descripción', 'Línea de oferta', 'Monto base', 'Total c/IVA'].map((col, i) => (
                      <th key={i} style={{ padding: '7px 12px', textAlign: ['Monto base', 'Total c/IVA'].includes(col) ? 'right' : 'left', fontWeight: '600', color: '#555', fontSize: '11px' }}>{col}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {hitosModal.map(h => (
                    <tr key={h.id} style={{ borderTop: '1px solid #f0f0f0' }}>
                      <td style={{ padding: '8px 12px', color: '#aaa' }}>{h.numero_hito}</td>
                      <td style={{ padding: '8px 12px', fontWeight: '500', color: '#012E40' }}>{h.descripcion}</td>
                      <td style={{ padding: '8px 12px' }}>
                        {h.oferta_linea_descripcion
                          ? <span style={{ background: '#f0f7e8', color: '#3B6D11', padding: '2px 7px', borderRadius: 8, fontSize: 10, fontWeight: 600 }}>{h.oferta_linea_descripcion}</span>
                          : <span style={{ color: '#ccc' }}>—</span>}
                      </td>
                      <td style={{ padding: '8px 12px', textAlign: 'right', color: '#555' }}>{fmt(h.monto, detalle?.moneda)}</td>
                      <td style={{ padding: '8px 12px', textAlign: 'right', fontWeight: '700', color: '#012E40' }}>{fmt(montoConIva(h), detalle?.moneda)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Total consolidado */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', background: '#e6f1fb', borderRadius: '8px', marginBottom: '16px' }}>
                <span style={{ fontSize: '13px', color: '#185FA5', fontWeight: '600' }}>Total a facturar (con IVA)</span>
                <span style={{ fontSize: '16px', color: '#012E40', fontWeight: '800' }}>{fmt(totalMod, detalle?.moneda)}</span>
              </div>

              <p style={{ fontSize: '12.5px', color: '#555', lineHeight: '1.6', margin: '0 0 20px' }}>
                Se enviará <strong>un único correo</strong> al encargado de facturación con todos los hitos listados. Cada hito cambiará a estado <strong style={{ color: '#185FA5' }}>Solicitada</strong>.
              </p>

              {/* Botones */}
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                <button onClick={() => setSolicitudModal(false)}
                  style={{ padding: '8px 20px', border: '1px solid #e0e0e0', borderRadius: '8px', background: '#fff', cursor: 'pointer', fontSize: '13px' }}>
                  Cancelar
                </button>
                <button onClick={confirmarSolicitud} disabled={solicitudEnviando}
                  style={{ padding: '8px 20px', background: solicitudEnviando ? '#aaa' : '#185FA5', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: solicitudEnviando ? 'not-allowed' : 'pointer' }}>
                  {solicitudEnviando ? 'Enviando...' : '📤 Revisar correo y enviar'}
                </button>
              </div>
            </div>
          </div>
        );
      })()}

      {/* MODAL REGISTRAR PAGO (delegado a PagosCliente) */}
      {pagoCliente && (
        <ModalPagoCliente
          cobroInicial={pagoCliente}
          onCerrar={() => setPagoCliente(null)}
          onGuardado={async () => { setPagoCliente(null); await cargar(); }}
        />
      )}

      {/* MODAL ANULAR FACTURA */}
      {anular && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 300 }}>
          <div style={{ background: '#fff', borderRadius: '14px', padding: '24px', width: '460px', maxWidth: '94vw' }}>
            <h3 style={{ color: '#A32D2D', fontSize: '16px', fontWeight: '700', margin: '0 0 6px' }}>Anular factura</h3>
            <p style={{ fontSize: '13px', color: '#555', margin: '0 0 14px', lineHeight: 1.5 }}>
              Se enviará un correo al encargado solicitando anular la factura <strong>{anular.numero_factura_cliente}</strong>{anular.cliente_nombre ? ` (${anular.cliente_nombre})` : ''} en el sistema. El cobro quedará marcado como <strong>Anulado</strong>.
            </p>
            <label style={{ fontSize: '11px', color: '#666', fontWeight: '600', display: 'block', marginBottom: '4px' }}>Motivo de la anulación *</label>
            <textarea value={anularMotivo} onChange={e => setAnularMotivo(e.target.value)} rows={3}
              placeholder="Ej: error en el monto, datos del cliente o proyecto equivocado"
              style={{ width: '100%', boxSizing: 'border-box', padding: '8px 10px', border: '1px solid #e0e0e0', borderRadius: '8px', fontSize: '13px', fontFamily: 'inherit', resize: 'vertical' }} />
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '16px' }}>
              <button onClick={() => { setAnular(null); setAnularMotivo(''); }} disabled={anularEnviando}
                style={{ padding: '8px 18px', border: '1px solid #e0e0e0', borderRadius: '8px', background: '#fff', cursor: 'pointer', fontSize: '13px' }}>Cancelar</button>
              <button onClick={confirmarAnulacion} disabled={anularEnviando || !anularMotivo.trim()}
                style={{ padding: '8px 18px', background: (anularEnviando || !anularMotivo.trim()) ? '#d9a' : '#A32D2D', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: (anularEnviando || !anularMotivo.trim()) ? 'default' : 'pointer' }}>
                {anularEnviando ? 'Enviando...' : 'Revisar correo y enviar'}
              </button>
            </div>
          </div>
        </div>
      )}

      {preview && (
        <PreviewCorreo
          titulo={preview.titulo}
          previewUrl={preview.previewUrl}
          sendUrl={preview.sendUrl}
          body={preview.body}
          enviarLabel={preview.enviarLabel}
          onClose={() => setPreview(null)}
          onSent={preview.onSent}
        />
      )}
    </div>
  );
}